import React from 'react'

export default class Cennik extends React.Component {
  render() {
    return (
      <>
        <div id="cennik">
          <div className="content">
            <p>
              Koszt wygenerowania dedykowanego programu ochrony wynosi 20
              złotych.
            </p>
            <p>
              Cena dotyczy programy dla jednej wybranej uprawy i jest
              niezależna, od tego czy program zawierał będzie cały program pełnej
              ochrony fungicydowej, herbicydowej i insektycydowej czy też
              poszczególnego jej wariantu.
            </p>
          </div>
        </div>
      </>
    )
  }
}
